import { ApiProperty } from '@nestjs/swagger'
import { IsNotEmpty, IsUUID, ValidateNested, IsArray } from 'class-validator'
import { Type } from 'class-transformer'
import { CreateActivityCompetencyLinkDto } from './create-activity-competency-link.dto'

class CompetencyLinkItemDto {
  @ApiProperty({ description: 'UUID de la compétence', format: 'uuid' })
  @IsUUID('4')
  programCompetencyId!: string

  @ApiProperty({ description: 'Niveau cible' })
  targetLevel!: string

  @ApiProperty({ description: 'Poids (1-5)', default: 3 })
  weight?: number
}

export class BulkCreateActivityCompetencyLinksDto {
  @ApiProperty({
    description: "UUID de l'activité",
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsNotEmpty()
  @IsUUID('4')
  activityId!: string

  @ApiProperty({
    description: 'Liens à créer',
    type: () => [CompetencyLinkItemDto],
  })
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => CompetencyLinkItemDto)
  links!: CompetencyLinkItemDto[]
}
